<template>
  <div
    v-for="singleLink in links"
    :key="singleLink.id"
    class="my-2 flex flex-nowrap items-center justify-between"
  >
    <i-heroicons-link class="mx-2 h-7 w-7" />
    <div class="flex-1 rounded bg-wild-sand p-2 text-center">
      {{ t("to") }}
      <span class="ml-1 font-bold">
        {{ singleLink.legal_text_paragraph_linked.paragraph }}
        {{ singleLink.legal_text_paragraph_linked.legal_text.name }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ILink, ILinkChain } from "~/models/IUserEntry";

const props = defineProps<{
  link: ILink | ILinkChain;
}>();

const { t } = useI18n({ useScope: "local" });

const links = computed(() => {
  const link = props.link;
  if ("links" in link) {
    return link.links;
  }
  return [link];
});
</script>

<i18n>
{
  "de": {
    "to": "zu"
  },
  "en": {
    "to": "to"
  }
}
</i18n>
